import * as React from "react";
import Grid from "@mui/material/Grid";
import { CmpTypographyField } from "../../../Component/Common/ToolBox/ToolBox";
import moment from "moment";
import { Typography } from "@mui/material";
export const DetailCard = ({ data = [], onClick = () => {} }) => {
 
  return (
     
    <Grid container spacing={1} className="easy-putaway-container mt-1">
      {data.map((item, index) => (
        <Grid item xs={12} sm={6} md={6} key={index} onClick={() => {
                  let items = { row: item };
                  onClick(items);
                }}
                style={{ display: 'flex' }}
                >
          <div className="easy-putaway-card"  style={{
            // display: 'flex',
            // flexDirection: 'column',
            // justifyContent: 'space-between', // Ensures content is spaced equally
            // flexGrow: 1, // This allows the card to grow and take up equal height 
            maxHeight: '210px', // Set a max height for the cards
            overflowY: 'auto', // Add scroll if content exceeds the height
          }}>
            <Grid container spacing={0.5} columns={{ xs: 12, md: 12 }}>
            <Grid item xs={6} md={3}>
                <Typography variant="subtitle1" className="label">
                ItmCd                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="body1" className="value">
                  {item.ItmCd}
                </Typography>
              </Grid>
              
             
              
             
              <Grid item xs={6} md={3}>
                <Typography variant="subtitle1" className="label" >
                Qty
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="body1" className="value">
                  {item.Qty}
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="subtitle1" className="label" >
                SegregatedQty
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="body1" className="value">
                  {item.SegregatedQty}
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="subtitle1" className="label" >
                Difference
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="body1" className="value">
                  {item.Difference}
                </Typography>
              </Grid>
              
              {/* <Grid item xs={6} md={3}>
                <Typography variant="subtitle1" className="label">
                ItmName
                </Typography>
              </Grid> */}
              <Grid item xs={12} md={12}>
                <Typography variant="body1" className="value">
                 {item.ItmName} 
                </Typography>
              </Grid>
              
            
             
            </Grid>
          </div>
        </Grid>
      ))}
    </Grid>
  );
};
